module.exports = __webpack_public_path__ + "media/images/tagline-header-3a0b891abb9e674673eb18ffbee08fb5.png";